import {
  getConnectionRuntimeConfigUrl,
  addConnectionRuntimeConfigUrl,
} from "./constants";
import base from "../middlewares/interceptors";

export const getPaginatedConnectionRuntimeConfig = async ({
  page,
  pSize,
  filterId,
  isActive,
  code,
  connection_type,
  signal,
}: any) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("size", pSize);
    if (filterId) {
      params.append("connection_runtime_config_filter_ids", filterId);
    }

    // Add is_active parameter if not "all"
    if (isActive !== "all") {
      const isActiveBoolean = isActive === "true" ? "true" : "false";
      params.append("is_active", isActiveBoolean);
    }

    // Add code filter if provided and has minimum 3 characters
    if (code && code.trim().length >= 3) {
      params.append("code", code.trim());
    }

    // Add connection_type filter if provided and has minimum 3 characters
    if (connection_type && connection_type.trim().length >= 3) {
      params.append("connection_type", connection_type.trim());
    }

    const response = await base.get(
      `${getConnectionRuntimeConfigUrl}?${params.toString()}`,
      { signal },
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getConnectionRuntimeConfigDetail = async ({
  currentConnectionRuntimeConfigId,
}: any) => {
  try {
    const params = new URLSearchParams();

    params.append(
      "connection_runtime_config_filter_ids",
      currentConnectionRuntimeConfigId,
    );

    const response = await base.get(
      `${getConnectionRuntimeConfigUrl}?${params.toString()}`,
    );
    // Return the first item from the paginated response
    return response.data?.items?.[0] || {};
  } catch (error) {
    console.error(error);
  }
};

export const addConnectionRuntimeConfig = async ({ payload }: any) => {
  try {
    const response = await base.post(addConnectionRuntimeConfigUrl, payload);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateConnectionRuntimeConfig = async ({
  currentConnectionRuntimeConfigId,
  payload,
}: any) => {
  try {
    const response = await base.put(
      `${addConnectionRuntimeConfigUrl}/${currentConnectionRuntimeConfigId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
export const deleteConnectionRuntimeConfig = async (
  currentConnectionRuntimeConfigId: number,
) => {
  try {
    const response = await base.delete(
      `${addConnectionRuntimeConfigUrl}/${currentConnectionRuntimeConfigId}`,
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const reactivateConnectionRuntimeConfig = async (
  connectionRuntimeConfigId: string | number,
) => {
  try {
    const response = await base.put(
      `${addConnectionRuntimeConfigUrl}/${connectionRuntimeConfigId}/reactivate`,
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating connection runtime config:", error);
    throw error;
  }
};

export const getAllConnectionRuntimeConfigs = async () => {
  try {
    const params = new URLSearchParams();
    const response = await base.get(
      `${getConnectionRuntimeConfigUrl}?${params.toString()}`,
    );
    return response.data?.items || [];
  } catch (error) {
    console.error("Error fetching all connection runtime configs:", error);
    throw error;
  }
};
